export default __webpack_public_path__ + "static/media/Mercenary's Chestguard of the Roaring Jungle.5931621e.jpg";